module.exports = __webpack_public_path__ + "img/past-experience.a54ad798.png";